module.exports = __webpack_public_path__ + "static/img/dummy_set_001.e54b3af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/set-menu/dummy_set_001.png
// module id = 6vbb
// module chunks = 1